export default {"src":"/_next/static/media/facebook.a370e5bd.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};